import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { EmailMessage, ThreadInfo } from "../email.types";
import Pusher from "pusher-js";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

import { EmailService } from "../email.service";
import { HotToastService } from "@ngneat/hot-toast";
import moment from "moment";
import { FilePreviewService } from "../../main/common/file-preview.service";
import {
  PinnedModels,
  PinnedModelsApps,
} from "../../main/accountant/pinned-panel/pinned-models";
import { PinnedService } from "../../main/accountant/pinned-panel/pinned.service";
import { JobsService } from "../../main/accountant/jobs-and-tasks/jobs.service";
import { Job } from "../../main/accountant/jobs-and-tasks/job.model";
import { DashboardStore } from "../../dashboard.store";
import { Company } from "../../shared-data.service";
import { MoveFileModalComponent } from "../../main/accountant/modals/move-file-modal.component";
import { environment } from "src/environments/environment";
import { Subscription } from "rxjs";
import { EscapeHtmlPipe } from "../../conversations/sanitizer.pipe";
import { MomentModule } from "ngx-moment";
import { ActiveClientsOnlyPipe } from "../../main/common/active-clients-only.pipe";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { EmailFormComponent } from "../email-form/email-form.component";
import { InitialsDirective } from "../../../utils/initials.directive";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass, NgIf, NgFor } from "@angular/common";
import { Editor } from "primeng/editor";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { BsDropdownModule, BsDropdownDirective } from "ngx-bootstrap/dropdown";
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";
import { JobNotificationService } from "../../main/accountant/shared/job-notification.service";
import { Pipe, PipeTransform } from "@angular/core";
import { MarkdownModule, provideMarkdown } from "ngx-markdown";

@Component({
  selector: "email-content",
  templateUrl: "./email-content.component.html",
  styleUrls: ["./email-content.component.scss", "../email.component.scss"],
  imports: [
    NgClass,
    NgIf,
    NgFor,
    TooltipModule,
    InitialsDirective,
    EmailFormComponent,
    CheckboxModule,
    FormsModule,
    TypeaheadModule,
    ActiveClientsOnlyPipe,
    MomentModule,
    EscapeHtmlPipe,
    PinComponent,
    BsDropdownModule,
    DialogModule,
    ProgressSpinnerModule,
    SkeletonModule,
    MarkdownModule,
  ],
  providers: [provideMarkdown()],
})
export class EmailContentComponent implements OnInit {
  private _thread: EmailMessage;

  // Removed this because it was too easy to accidentally delete an email
  // @HostListener("document:keydown", ["$event"])
  // handleTheKeyboardEvent(event: KeyboardEvent) {
  //   switch (event.key) {
  //     case "Delete":
  //       this.moveToTrash();
  //       event.preventDefault();
  //       break;
  //   }
  // }

  @Input() mailbox: string = "PRIORITY";
  @Input() isFromDrawer: boolean = false;
  jobCreationLoading: boolean;

  @Input() set thread(value: EmailMessage) {
    this._thread = value;

    console.log("thread", this.thread);

    this.getEmailThread(this.thread);

    this.setComposeMode(false);

    this.summaryText = ""; // Reset summaryText when navigating to another email

    if (this.thread != null) {
      this.refreshEmailInfo();

      if (this.thread.inbox) {
        this.emailService
          .getInboxSettings(this.thread.inbox)
          .subscribe((res) => {
            this.settings.signature = res["signature"];
            this.settings.greeting = res["greeting"];
          });
      }
    }
  }

  get thread(): EmailMessage {
    return this._thread;
  }

  threadUUID: any = null;
  threadInfo: ThreadInfo = null;

  to: any = null;
  subject: any = null;
  message: any = null;

  modifiedMessage: any = null;

  composeMode = false;
  summary = false;
  cc = false;
  bcc = false;
  summarizeLoading = false;
  generateAiLoading = false;
  changeEmailToneLoading = false;
  generateMagicEmailLoading = false;

  newEmail: any = {
    to: [],
    cc: [],
    bcc: [],
    subject: "",
    body: "",
  };

  settings: any = {
    signature: "",
    greeting: "",
  };

  inboxAddress = null;

  collapsed = true;

  emailBody: any = null;
  pusher: Pusher;
  emailChannel: any;

  inboxState: string = null;

  loading = false;

  imapPassword: string = null;

  public bsModalRef: BsModalRef;

  targetStartDate: any;
  dueDate: any;
  assignedTo: any = null;

  duplicateSelectedObj: any = null;
  duplicateSelected: string = "";

  accountants: any = [];

  datepickerFormat = "mm-dd-yy";
  availableStaff = null;

  magicReplyPrompt: string = "";

  selectedWorkspaces = [];

  public inlineMode: object = { enable: true, onSelection: true };
  public toolbarSettings: Object = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "Formats",
      "-",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "CreateLink",
    ],
  };

  pinModel = PinnedModels.Thread;

  @ViewChild("messageInput", { static: false })
  messageInput: Editor;

  @ViewChild(BsDropdownDirective, { static: false }) dropdown:
    | BsDropdownDirective
    | undefined;

  env = environment;
  private subscriptions = new Subscription();
  workspaceSearchText: string = "";

  visible: boolean = false;
  position: string;
  animateSummary: boolean = false;
  summaryText: string = "";
  cursorVisible: boolean = false;
  typingSpeed: number = 10; // Default typing speed
  showWorkspacesActionsDropdown: boolean = true;

  isEditingEmailBody: boolean = false;
  showSelectedWorkspaces: boolean = false;

  constructor(
    private emailService: EmailService,
    private toastr: HotToastService,
    public modalService: BsModalService,
    private filePreviewService: FilePreviewService,
    private pinnedService: PinnedService,
    private jobsService: JobsService,
    public dashboardStore: DashboardStore,
    private cdr: ChangeDetectorRef,
    private jobNotificationService: JobNotificationService, // Inject the shared service
  ) {}

  ngOnInit(): void {
    this.jobNotificationService.jobDeleted$.subscribe(() => {
      console.log("Job deleted event received in email-content component"); // Debug log
      this.refreshEmailInfo();
      this.cdr.detectChanges(); // Ensure change detection is triggered
      // hide the dom element with class "job-modal"
      const jobModal = document.querySelector(".job-modal") as HTMLElement;
      if (jobModal) {
        jobModal.classList.remove("show");
        jobModal.setAttribute("aria-hidden", "true");
        jobModal.style.display = "none";
      }
    });
  }

  sendEmail(address, cc = [], bcc = []) {
    this.emailService
      .sendEmail(
        this.newEmail.to,
        this.newEmail.subject,
        this.modifiedMessage != null
          ? this.modifiedMessage
          : this.newEmail.body,
        this.newEmail.cc,
        this.newEmail.bcc,
        this.thread.messages[this.thread.messages.length - 1]["internal_id"],
      )
      .subscribe(
        (data: any) => {
          this.message = null;
          this.modifiedMessage = null;
          this.toastr.success("Email sent");

          this.newEmail = {
            to: [],
            cc: [],
            bcc: [],
            subject: "",
            body: "",
          };

          this.setComposeMode(false);
        },
        (err) => {
          this.toastr.error(err.error.message);
        },
      );
  }

  refreshEmailInfo() {
    this.emailService
      .getThreadInfo(this.thread.uuid)
      .then((data: ThreadInfo) => {
        console.log("threadInfo", data);
        this.threadInfo = data;
        this.selectedWorkspaces = this.threadInfo.linked_workspaces.map(
          ({ uuid }) => uuid,
        );

        this.emailService
          .getThreadWorkspaces(this.threadUUID)
          .then((res: []) => {
            this.threadInfo.available_workspaces = res;
          });

        this.emailService
          .getThreadAttachments(this.threadUUID)
          .then((res: any) => {
            console.log("thread attachments", res);

            this.thread.messages.forEach((message) => {
              message.attachments_list = res[message.uuid];
            });

            console.log("thread messages", this.thread.messages);

            this.thread.messages.forEach((message) => {
              message.attachments_list.forEach((attachment) => {
                this.getAttachmentContent(attachment);
              });
            });
          });

        if (this.threadInfo.client_company != null) {
          this.jobsService
            .getAccountantsFromClientCompany(this.threadInfo.client_company.id)
            .then((res: any) => {
              this.accountants = res.accountants;
              this.availableStaff = res.accountants.map((acc: any) => acc.user);
            });
        }
      });
  }

  changeEmailTone(tone) {
    this.changeEmailToneLoading = true;
    this.emailService
      .changeEmailTone(this.newEmail.body, tone, this.thread.uuid)
      .then((res: any) => {
        this.modifiedMessage = res.email;
        this.changeEmailToneLoading = false;
      });
  }

  summarizeThread() {
    this.summarizeLoading = true;
    this.emailService.summarizeThread(this.threadUUID).subscribe((res: any) => {
      this.thread.summary = res.summary;
      this.summarizeLoading = false;
      this.animateSummaryText(res.summary);
    });
  }

  animateSummaryText(text: string) {
    this.summaryText = "";
    this.cursorVisible = true;
    let index = 0;

    const interval = setInterval(() => {
      if (index < text.length) {
        this.summaryText += text[index];
        index++;
      } else {
        clearInterval(interval);
        this.cursorVisible = false;
      }
    }, this.typingSpeed); // Use typing speed here
  }

  openSummarizeThreadDialog() {
    if (!this.thread?.summary) {
      this.summarizeThread();
    } else {
      this.summaryText = this.thread.summary;
      this.cursorVisible = false;
    }
    this.visible = true;
  }

  startAnimation() {
    this.animateSummary = true;
    setTimeout(
      () => (this.animateSummary = false),
      this.thread.summary.length * 20,
    ); // Adjust timing based on typing speed
  }

  openFile(file) {
    this.filePreviewService.openFile.next({ file: file });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getFileExt(filename) {
    if (filename !== undefined && filename !== null) {
      return filename.split(".").pop();
    } else {
      return null;
    }
  }

  // this function transforms an email attachment into a file-like
  // object that is used by the file preview component
  openAttachment(attachment, message) {
    let file = { file: {} };
    file.file["filename"] = attachment.filename;
    file.file["etag"] = attachment.id;
    file.file["ext"] = this.getFileExt(attachment.filename);
    file.file["mime_type"] = attachment.contentType;
    file.file["from_conversation"] = false;
    file.file["file"] = environment.apiUrl + attachment.url;
    file.file["url"] = environment.apiUrl + attachment.secure_url;
    file.file["secure_url"] = attachment.secure_url;
    file.file["from_email"] = true;
    file.file["from_attachment"] = true;
    file.file["attachment"] = attachment;
    file.file["inbox"] = this.thread.inbox;
    file.file["emailMessage"] = message;

    // we do that to get all the information needed in the move file modal
    let linkedWorkspaces = this.threadInfo.linked_workspaces.map(
      (workspace) => {
        let workspaceData = this.dashboardStore.clients.find(
          (client) => client.uuid === workspace.uuid,
        );

        return workspaceData;
      },
    );

    file.file["availableWorkspaces"] = linkedWorkspaces;

    this.filePreviewService.openFile.next(file);

    this.subscriptions = this.filePreviewService.closeFile.subscribe((res) => {
      console.log("file preview closed");
      this.emailService
        .getThreadWorkspaces(this.threadUUID)
        .then((res: any) => {
          if (this.threadInfo.client_company == null) {
            if (res.length > 0) {
              this.threadInfo.client_company = res[0];
            }
          }

          this.threadInfo.available_workspaces = res;
          this.subscriptions.unsubscribe();
        });
    });
  }

  openCreateJobModal(modal) {
    this.duplicateSelectedObj = null;
    this.duplicateSelected = null;

    this.bsModalRef = this.modalService.show(modal, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  openLinkWorkspaceModal(modal) {
    this.duplicateSelectedObj = null;
    this.duplicateSelected = null;

    this.bsModalRef = this.modalService.show(modal, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  createJob(workspace = null) {
    this.jobCreationLoading = true;
    this.emailService
      .createJob(
        this.thread.uuid,
        workspace ? workspace.id : this.duplicateSelectedObj.id,
      )
      .subscribe(
        (res: any) => {
          // Link workspace in case that its not linked yet
          if (
            this.threadInfo.client_company &&
            this.threadInfo.linked_workspaces.length == 0
          ) {
            this.linkThreadToWorkspace();
          }
          if (
            !this.threadInfo.client_company &&
            this.threadInfo.linked_workspaces.length == 0
          ) {
            this.toastr.success("Thread linked to workspace successfully");
          }

          // Open job after creating it
          this.jobCreationLoading = false;
          this.openJob(res.job.uuid);

          this.toastr.success("Job created");
          this.refreshEmailInfo();
          this.bsModalRef.hide();

          this.duplicateSelectedObj = null;
          this.duplicateSelected = null;
        },
        (err) => {
          this.jobCreationLoading = false;
          this.toastr.error(
            "Error creating job: " + (err.error?.message || "Unknown error"),
          );
        },
      );
  }

  selectClient(event) {
    this.duplicateSelectedObj = event.item;
  }

  openJob(uuid = this.threadInfo.related_job.uuid) {
    this.jobsService.getJob(uuid).then((res: any) => {
      const jobModal = document.querySelector(".job-modal") as HTMLElement;
      if (jobModal) {
        jobModal.classList.add("show");
        jobModal.setAttribute("aria-hidden", "false");
        jobModal.style.display = "block";
      }
      this.showWorkspacesActionsDropdown = false;
      setTimeout(() => {
        this.showWorkspacesActionsDropdown = true;
      }, 0);
      this.dashboardStore._selectJob.next(res);
    });
  }

  setAssignee(user) {
    this.assignedTo = user;
  }

  setComposeMode(mode) {
    this.composeMode = mode;

    if (this.composeMode == true) {
      this.newEmail.body =
        this.settings.greeting + "\n\n" + this.settings.signature;

      setTimeout(() => {
        this.messageInput.getQuill().focus();
      }, 10);
    }
  }

  moveToTrash() {
    this.loading = true;
    this.emailService.deleteEmailThread(this.threadUUID).subscribe(
      (res) => {
        this.loading = false;
        this.toastr.success("Email moved to trash");
        this.emailService.resetEmailState$.next(null);
      },
      (err) => {
        this.loading = false;
        this.toastr.error("Error moving email to trash");
      },
    );
  }

  archiveThread() {
    this.loading = true;
    this.emailService.archiveEmailThread(this.threadUUID).subscribe(
      (res) => {
        this.toastr.success("Email archived successfully");
        this.loading = false;
        this.emailService.resetEmailState$.next(null);
      },
      (err) => {
        this.loading = false;
        this.toastr.error("Error archiving email");
      },
    );
  }

  generateMagicEmail() {
    this.generateMagicEmailLoading = true;
    this.emailService
      .magicEmail(this.magicReplyPrompt, this.threadUUID)
      .subscribe(
        (res: any) => {
          this.newEmail.body =
            this.settings.greeting +
            "\n\n" +
            res.email +
            "\n\n" +
            this.settings.signature;

          this.bsModalRef.hide();
        },
        (err) => {
          this.toastr.error(
            "Error generating magic response. Please try again",
          );
        },
        () => {
          this.generateMagicEmailLoading = false;
        },
      );
  }

  openModal(template) {
    this.bsModalRef = this.modalService.show(template, {
      class: "create-ai-job-modal modal-md",
    });
  }

  openPinEmailModal(modal) {
    if (this.threadInfo.client_company != null) {
      this.pinEmail();
      return;
    } else {
      this.bsModalRef = this.modalService.show(modal, {
        class: "duplicate-job-modal modal-sm",
      });
    }
  }

  async pinEmail() {
    const data = {
      model_name: PinnedModels.Thread,
      model_app_name: PinnedModelsApps.Thread,
      object_pk: this.thread["id"],
    };

    const { pinned_item, message } = await this.pinnedService.pinItem(
      data,
      this.threadInfo.client_company != null
        ? this.threadInfo.client_company.uuid
        : this.duplicateSelectedObj.uuid,
    );

    this.cdr.detectChanges();
    this.toastr.success(message);
    this.bsModalRef.hide();

    this.refreshEmailInfo();
  }

  getEmailThread(thread) {
    this.threadInfo = null;

    if (thread != null) {
      this.threadUUID = thread.uuid;
      // this.setComposeMode(false); // call this function in email-content

      this.loading = true;
      this.emailService
        .getEmailThread(thread.uuid)
        .subscribe((data: EmailMessage[]) => {
          this.thread.messages = data;

          this.newEmail = {
            to: [],
            cc: [],
            bcc: [],
            subject: "",
            body: "",
          };

          if (this.thread.messages[this.thread.messages.length - 1] != null) {
            if (
              this.thread.messages[this.thread.messages.length - 1]["cc"] !=
              null
            ) {
              this.newEmail.cc = this.thread.messages[
                this.thread.messages.length - 1
              ]["cc"].map((address) => {
                return address.address;
              });
            }
          }

          this.newEmail.to.push(this.thread.from_email.address);

          this.loading = false;

          this.emailService.readEmailThread(thread.uuid).then(
            (data: any) => {
              thread.unread = false;
            },
            (err) => {},
          );
          this.summaryText = this.thread?.summary;
        });
    }
  }

  linkThreadToWorkspace(workspace = null) {
    this.emailService
      .linkThreadToWorkspace(
        this.threadUUID,
        workspace ? workspace.uuid : this.duplicateSelectedObj.uuid,
      )
      .then(
        (res: any) => {
          this.threadInfo = res.thread_info;

          this.refreshEmailInfo();

          this.bsModalRef.hide();
          this.toastr.success("Thread linked to workspace successfully");
        },
        (err) => {
          this.bsModalRef.hide();
          this.toastr.error("Error linking thread to workspace");
        },
      );
  }

  checkIfCanUnlink(workspace) {
    if (this.isWorkspaceLinked(workspace.uuid)) {
      if (!workspace.toastrShown) {
        this.toastr.error(
          "Can't unlink because there's jobs or pins related to this workspace.",
        );
        workspace.toastrShown = true;
        setTimeout(() => {
          workspace.toastrShown = false;
        }, 3000); // Reset after 3 seconds to allow showing again if needed
      }
    }
  }

  addThreadToWorkspaceCheckBox(event, workspace, pin = false) {
    if (this.isWorkspaceLinked(workspace.uuid)) {
      event.preventDefault();
      event.target.checked = true;
      return;
    }

    this.duplicateSelectedObj = event.checked ? workspace : null;
    const data = [
      {
        uuid: workspace.uuid,
        selected: this.selectedWorkspaces.includes(workspace.uuid),
      },
    ];
    this.emailService
      .updateThreadWorkspaces(this.threadUUID, data)
      .then((res: any) => {
        this.threadInfo.linked_workspaces = res.linked_workspaces;
        this.selectedWorkspaces = res.linked_workspaces.map(({ uuid }) => uuid);
        this.refreshEmailInfo();
      });
  }

  getAttachmentContent(attachment) {
    this.emailService
      .getAttachmentContent(this.thread.inbox, attachment.id)
      .subscribe(
        (res: any) => {
          const blob = new Blob([res], { type: attachment["contentType"] });
          const _url = window.URL.createObjectURL(blob);

          for (let i = 0; i < this.thread.messages.length; i++) {
            for (
              let j = 0;
              j < this.thread.messages[i].attachments_list.length;
              j++
            ) {
              if (
                this.thread.messages[i].attachments_list[j].id == attachment.id
              ) {
                this.thread.messages[i].attachments_list[j].secure_url = _url;
              }
            }
          }

          return _url;
        },
        (err) => {},
      );
  }

  toggleShowSelectedWorkspaces(event: Event) {
    event.preventDefault();
    this.showSelectedWorkspaces = !this.showSelectedWorkspaces;
  }

  closeDropdown(dropdown: BsDropdownDirective): void {
    if (dropdown) {
      dropdown.hide();
    } else {
      console.warn("Dropdown reference is not defined.");
    }
  }

  isWorkspaceLinked(workspaceUuid: string): boolean {
    return this.threadInfo?.linked_workspaces?.some(
      (linked) =>
        linked.uuid === workspaceUuid &&
        (linked.job_uuid || linked.pinned_item),
    );
  }

  onPinActionCompleted() {
    this.refreshEmailInfo();
    this.cdr.detectChanges();
  }

  onJobDeleted() {
    console.log("Job deleted event received in email-content component"); // Debug log
    this.refreshEmailInfo();
    this.cdr.detectChanges(); // Ensure change detection is triggered
  }
}

@Pipe({
  name: "sortSelectedWorkspaces",
})
export class SortSelectedWorkspacesPipe implements PipeTransform {
  transform(workspaces: any[], selectedWorkspaces: string[]): any[] {
    return workspaces.sort((a, b) => {
      const aSelected = selectedWorkspaces.includes(a.uuid);
      const bSelected = selectedWorkspaces.includes(b.uuid);
      return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
    });
  }
}

@Pipe({
  name: "filterWorkspaces",
})
export class FilterWorkspacesPipe implements PipeTransform {
  transform(workspaces: any[], searchText: string): any[] {
    if (!searchText) return workspaces;
    return workspaces.filter((workspace) =>
      workspace.name.toLowerCase().includes(searchText.toLowerCase()),
    );
  }
}

@Pipe({
  name: "showSelectedWorkspaces",
})
export class ShowSelectedWorkspacesPipe implements PipeTransform {
  transform(
    workspaces: any[],
    showSelected: boolean,
    selectedWorkspaces: string[],
  ): any[] {
    if (!showSelected) return workspaces;
    return workspaces.filter((workspace) =>
      selectedWorkspaces.includes(workspace.uuid),
    );
  }
}
